<div class="nova-root rcm-page">
  <nova-icon-registry></nova-icon-registry>

  <div class="rcm-band">
    <div class="rcm-band__inner">
      <header class="rcm-header">
        <div class="rcm-header__titles">
          <h1 class="nova-heading-28 rcm-header__title">RON Closing Monitor</h1>
          <div class="rcm-header__dateline" *ngIf="date$ | async as date">
            <app-monitor-date-picker
              [value]="date"
              (dateChange)="onDateChange($event)"
            ></app-monitor-date-picker>
            <p class="nova-body-16 rcm-header__date">
              <span data-testid="selected-date">
                {{ date | date : 'fullDate' }}
              </span>
              <span class="rcm-header__age" data-testid="data-age">
                <ng-container *ngIf="boardTime$ | async as boardTime; else noAge">
                  · updated {{ boardTime | date : 'shortTime' }}
                </ng-container>
                <ng-template #noAge>· not yet updated</ng-template>
              </span>
            </p>
          </div>
        </div>
        <button novaButton variant="secondary" size="small" (click)="refresh()">
          <nova-icon name="refresh" size="small"></nova-icon>
          Refresh
        </button>
      </header>
    </div>
  </div>

  <div class="rcm-band rcm-band--tight">
    <div class="rcm-band__inner">
      <app-summary-cards
        [summary]="summary$ | async"
      ></app-summary-cards>
    </div>
  </div>

  <div class="rcm-band">
    <div class="rcm-band__inner">
      <section aria-label="Notary schedule">
        <div class="rcm-toolbar">
          <div
            novaTabs
            [value]="(segment$ | async) ?? 'all'"
            (valueChange)="onSegmentChange($event)"
          >
            <div novaTabsList density="medium">
              <button novaTabsItem value="all">
                <span novaTabsItemContent>All</span>
              </button>
              <button novaTabsItem value="tsa">
                <span novaTabsItemContent>TSA</span>
              </button>
              <button novaTabsItem value="preferred">
                <span novaTabsItemContent>PA (Preferred agents)</span>
              </button>
            </div>
          </div>

          <div class="rcm-search">
            <label class="rcm-search__label" for="rcm-search-input">
              Search notary, loan number, or order number
            </label>
            <input
              id="rcm-search-input"
              class="rcm-search__input"
              type="search"
              placeholder="Notary, Loan #, or Order #"
              [value]="(searchTerm$ | async) ?? ''"
              (input)="onSearch($any($event.target).value)"
            />
            <span class="rcm-search__button" aria-hidden="true">
              <nova-icon name="search" size="small"></nova-icon>
            </span>
          </div>
        </div>

        <app-notary-grid
          [lanes]="(lanes$ | async) ?? []"
          [closings]="(closings$ | async) ?? []"
          [now]="boardTime$ | async"
          [searchTerm]="(searchTerm$ | async) ?? ''"
          [expandedPackageIds]="(expandedPackageIds$ | async) ?? []"
          [details]="(details$ | async) ?? {}"
          (pillActivate)="onPillActivate($event)"
          (panelRetry)="onPanelRetry($event)"
          (panelDismiss)="onPanelDismiss($event)"
        ></app-notary-grid>
      </section>
    </div>
  </div>
</div>
